import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 13h-5v5h5v-5zM16 2v2H8V2H6v2H3.01L3 22h18V4h-3V2h-2zm3 18H5V9h14v11z"
}), 'EventSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EventSharp.js
// module id = 3431
// module chunks = 2